// import appStore from '@/src/state/appStore'
const UserPosts = { template: "<div>Posts</div>" };
import Wh from "@views/wh";
import WhOverview from "@views/wh_overview";
import WhTunnels from "@views/wh_tunnels";
import WhKeys from "@views/wh_keys";

import Radar from "@views/radar";
import RadarOverview from "@views/radar_overview";
import RadarEvents from "@views/radar_events";
import RadarRules from "@views/radar_rules";

import Engine from "@views/engine";
import EngineKeys from "@views/engine_keys";
import EngineAtoms from "@views/engine_atoms";
import EngineAssets from "@views/engine_assets";
import EngineOverview from "@views/engine_overview";

export default [
  {
    path: "/",
    name: "home",
    component: () => lazyLoadView(import("@views/home")),

    // props: route => ({authToken: store.state.auth.token || {}})
  },
  {
    path: "/way-home",
    name: "wh",
    component: Wh,
    meta: {
      showSubmenu: true,
    },
    children: [
      {
        path: "",
        component: WhOverview,
        name: "wh_overview",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "tunnels",
        component: WhTunnels,
        name: "wh_tunnels",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "keys",
        component: WhKeys,
        name: "wh_keys",
        meta: {
          showSubmenu: true,
        },
      },
      // {
      //   path: "",
      //   component: () => lazyLoadView(import("@views/tunnels_list")),
      //   name: "tunnels_list",
      //   meta: {
      //     showSubmenu: false,
      //   },
      // },

      // {
      //   path: "keys",
      //   name: "tunnels_keys",
      //   component: () => lazyLoadView(import("@views/tunnels_keys")),
      //   meta: {
      //     showSubmenu: false,
      //   },
      // },
    ],
  },
  {
    path: "/radar",
    name: "radar",
    component: Radar,
    meta: {
      showSubmenu: true,
    },
    children: [
      {
        path: "",
        component: WhOverview,
        name: "radar_overview",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "events",
        component: RadarEvents,
        name: "radar_events",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "rules",
        component: RadarRules,
        name: "radar_rules",
        meta: {
          showSubmenu: true,
        },
      }
    ],
  },

  {
    path: "/engine",
    name: "engine",
    component: Engine,
    meta: {
      showSubmenu: true,
    },
    children: [
      {
        path: "",
        component: EngineOverview,
        name: "engine_overview",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "keys",
        component: EngineKeys,
        name: "engine_keys",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "atoms",
        component: EngineAtoms,
        name: "engine_atoms",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "assets",
        component: EngineAssets,
        name: "engine_assets",
        meta: {
          showSubmenu: true,
        },
      }
    ],
  },

  {
    path: "/profile/",
    name: "profile",
    component: () => lazyLoadView(import("@views/profile")),
  },
  {
    path: "/projects/new/",
    name: "projects_new",
    component: () => lazyLoadView(import("@views/projects_new")),
    children: [
      {
        path: ":hash/",
        component: () => lazyLoadView(import("@views/projects_new")),
        name: "projects_new_hash",
      },
    ],
  },
  {
    path: "/project/:hash/",
    component: () => lazyLoadView(import("@views/project")),
    meta: {
      showSubmenu: true,
    },
    children: [
      {
        path: "",
        component: () => lazyLoadView(import("@views/project_overview")),
        name: "project_overview",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "settings",
        name: "project_settings",
        component: () => lazyLoadView(import("@views/project_settings")),
        meta: {
          showSubmenu: true,
        },
      },
    ],
  },

  {
    name: "scan_overview",
    path: "/scan/:hash/",
    component: () => lazyLoadView(import("@views/scan_overview")),
  },

  {
    path: "/target/:hash/",
    component: () => lazyLoadView(import("@views/target")),
    children: [
      {
        path: "",
        component: () => lazyLoadView(import("@views/target_overview")),
        name: "target_overview",
        meta: {
          showSubmenu: true,
        },
      },
      {
        path: "settings",
        name: "target_settings",
        component: UserPosts,
        meta: {
          showSubmenu: true,
        },
      },
    ],
  },
  {
    path: "/test",
    name: "test",
    component: () => lazyLoadView(import("@views/test")),
  },
  {
    path: "/login",
    name: "login",
    component: () => lazyLoadView(import("@views/login")),
    meta: {
      public: true,
    },
  },
  {
    path: "/register",
    name: "register",
    component: () => lazyLoadView(import("@views/register")),
    meta: {
      public: true,
    },
  },
  {
    path: "/confirm-account",
    name: "confirm-account",
    component: () => lazyLoadView(import("@views/confirm")),
    meta: {
      public: true,
    },
  },
  {
    path: "/forget-password",
    name: "forget-password",
    component: () => lazyLoadView(import("@views/forgetPassword")),
    meta: {
      beforeResolve(routeTo, routeFrom, next) {
        // If the user is already logged in
        /*
        if (store.getters['auth/loggedIn']) {
          // Redirect to the home page instead
          next({name: 'home'})
        } else {
          // Continue to the login page
          next()
        }
        */
      },
    },
  },
  {
    // axios.post('/api/secure/logout')
    path: "/logout",
    name: "logout",
    meta: {
      authRequired: true,
    },
    component: () => lazyLoadView(import("@views/logout")),
  },
  {
    path: "/404",
    name: "404",
    component: require("@views/_404").default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  {
    path: "/500",
    name: "500",
    component: require("@views/_500").default,
    // Allows props to be passed to the 404 page through route
    // params, such as `resource` to define what wasn't found.
    props: true,
  },
  // Redirect any unmatched routes to the 404 page. This may
  // require some server configuration to work in production:
  // https://router.vuejs.org/en/essentials/history-mode.html#example-server-configurations
  {
    path: "*",
    redirect: "404",
  },
];

// Lazy-loads view components, but with better UX. A loading view
// will be used if the component takes a while to load, falling
// back to a timeout view in case the page fails to load. You can
// use this component to lazy-load a route with:
//
// component: () => lazyLoadView(import('@views/my-view'))
//
// NOTE: Components loaded with this strategy DO NOT have access
// to in-component guards, such as beforeRouteEnter,
// beforeRouteUpdate, and beforeRouteLeave. You must either use
// route-level guards instead or lazy-load the component directly:
//
// component: () => import('@views/my-view')
//
function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    // A component to use while the component is loading.
    loading: require("@views/_loading").default,
    // Delay before showing the loading component.
    // Default: 200 (milliseconds).
    delay: 2000,
    // A fallback component in case the timeout is exceeded
    // when loading the component.
    error: require("@views/_timeout").default,
    // Time before giving up trying to load the component.
    // Default: Infinity (milliseconds).
    timeout: 10000,
  });

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      // Transparently pass any props or children
      // to the view component.
      return h(AsyncHandler, data, children);
    },
  });
}
